export const PAYMENTS = {
        adminPage: 'admin-payment-gateway-page',
        mode: 'payment-mode',
        env: 'payment-env',
        merchantCode: 'payment-merchant-code',
        apiKey: 'payment-api-key',
        publicUrl: 'payment-public-url',
        defaultMethod: 'payment-default-method',
        expiry: 'payment-expiry',
        saveBtn: 'payment-save',
        testBtn: 'payment-test',
        callbackUrl: 'payment-callback-url',
        copyCallback: 'payment-copy-callback',
        testResult: 'payment-test-result',
};
